import React, { useState, useEffect } from "react";
import { Modal, ModalHeader, ModalBody } from "reactstrap";
import { isNewSimulationVersion } from "src/utils/common";
import { useTranslation } from "react-i18next";
import "react-json-view-lite/dist/index.css";
import { useFileContentUtils } from "./useFileContentUtils";
import { useTabManager } from "./useTabManager";
import TabNavigation from "./components/TabNavigation";
import TabContentArea from "./components/TabContentArea";

const ModalFlightSimulatorSeriesFilesView = ({
  isOpen,
  serieData,
  fileData,
  onClose,
  simulationType,
  executionFileName,
  simulationVersion,
}) => {
  const { t } = useTranslation("flight-simulator");
  const [toggle, setToggle] = useState(false);
  const [activeTab, setActiveTab] = useState(1);
  const [scrollPositionById, setScrollPositionById] = useState({ 1: 0, 2: 0 });

  const isNewVersion = isNewSimulationVersion(simulationVersion);

  const { isHasExcelFiles, getAeroContent, getExcelFilesContent, isCSVContent, showJsonContent } = useFileContentUtils(t);
  const { getTabId } = useTabManager(fileData, serieData, simulationType, executionFileName, isNewVersion, isHasExcelFiles);

  useEffect(() => {
    setToggle(isOpen);
    if (isOpen) {
      setActiveTab(1);
      setScrollPositionById({ 1: 0, 2: 0 });
    }
  }, [isOpen]);

  const closeModal = () => {
    onClose();
    setToggle(false);
    setTimeout(() => {
      document.activeElement.blur();
    }, 500);
  };

  const getScrollPosition = () => {
    const div = document.getElementById("tabContentModal");
    return div.scrollTop;
  };

  const toggleTab = (tab) => {
    const scrollPosition = getScrollPosition();
    const previousActiveTab = activeTab;

    setScrollPositionById((prev) => ({
      ...prev,
      [previousActiveTab]: scrollPosition,
    }));

    setActiveTab(tab);
  };

  useEffect(() => {
    const div = document.getElementById("tabContentModal");
    if (div && scrollPositionById[activeTab] !== undefined) {
      div.scrollTop = scrollPositionById[activeTab];
    }
  }, [activeTab, scrollPositionById]);

  return (
    <Modal
      centered
      isOpen={toggle}
      toggle={closeModal}
      className="modal-full-width"
      backdrop="static"
      contentClassName="modal-content-flight-simulator"
    >
      <ModalHeader className="p-b-0" toggle={closeModal}></ModalHeader>
      <ModalBody>
        <TabNavigation
          fileData={fileData}
          serieData={serieData}
          activeTab={activeTab}
          simulationType={simulationType}
          executionFileName={executionFileName}
          isNewVersion={isNewVersion}
          isHasExcelFiles={isHasExcelFiles}
          getTabId={getTabId}
          onTabChange={toggleTab}
          t={t}
        />
        <TabContentArea
          activeTab={activeTab}
          fileData={fileData}
          serieData={serieData}
          simulationType={simulationType}
          executionFileName={executionFileName}
          isNewVersion={isNewVersion}
          isHasExcelFiles={isHasExcelFiles}
          getTabId={getTabId}
          getAeroContent={getAeroContent}
          getExcelFilesContent={getExcelFilesContent}
          isCSVContent={isCSVContent}
          showJsonContent={showJsonContent}
          t={t}
        />
      </ModalBody>
    </Modal>
  );
};

export default ModalFlightSimulatorSeriesFilesView;
